import { Box, Collapse, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import TransactionIconsMapping from "src/components/transactions/TransactionIconsMapping";
import InnerTable from "./InnerTable";
import { createDataMobile, iconSelector } from "./helperfns";
import { TransactionPaperStyle } from "./styles/TransactionPaper.styles";
import TransactionDetails from "./TransactionDetails";
import TransferStatusPill, {
  statusToPillVariant,
} from "src/components/transfers/TransferStatusPill";

interface TransactionItemProps {
  transaction: ReturnType<typeof createDataMobile>;
  date?: string;
}

const TransactionItem = (props: TransactionItemProps) => {
  const { transaction, date } = props;
  const theme = useTheme();
  const history = useHistory();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [collaspe, setCollaspe] = React.useState<boolean>(false);
  const [showTransactionDetails, setShowTransactionDetails] = React.useState(false);
  const classes = TransactionPaperStyle();
  // D6 — when the transaction has a TR-relevant orchestrator status,
  // surface it as a pill on the row. Clicking the pill takes the user to
  // the new `/transfers/:id` detail page.
  const trVariant = statusToPillVariant((transaction as any).trStatus);

  // hide or show transactionDetails component
  const TransactionDetailsToggle = (): void => {
    setShowTransactionDetails((prev): boolean => !prev);
  };

  const contains = (type: string, status: string): boolean => {
    return status?.toLowerCase()?.includes(type);
  };

  const listItem = React.useMemo(() => {
    const base = transaction.lines[1] ?? transaction.lines[0];
    const quote = transaction.lines[0] ?? transaction.lines[1];
    return (
      <div
        style={{
          cursor: isTablet ? "pointer" : "",
        }}
        onClick={() => {
          if (isTablet) {
            setCollaspe((prev) => !prev);
          }
          TransactionDetailsToggle();
        }}>
        <Grid container className={classes.content}>
          <Grid item xs={6} className={classes.leftContent}>
            {/* Icon */}
            <Grid item className={classes.icon}>
              {iconSelector(transaction.type)}
            </Grid>
            <Grid container ml={1}>
              <Grid item xs={12}>
                <Typography className={classes.title}>{transaction.type}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.time}>
                  {contains("completed", transaction.status[1]) && <span>{transaction.time}</span>}
                  {contains("open", transaction.status[1]) && <span>open</span>}
                  {contains("cancelled", transaction.status[1]) && <span>Cancelled</span>}
                  {contains("pending", transaction.status[1]) && <span>Pending</span>}
                  {contains("requested", transaction.status[1]) && <span>Requested</span>}
                </Typography>
              </Grid>
              {trVariant && (
                <Grid item xs={12} sx={{ mt: 0.5 }}>
                  <Box
                    component="span"
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation();
                      history.push(`/transfers/${transaction.id}`);
                    }}
                    sx={{ cursor: "pointer" }}>
                    <TransferStatusPill status={trVariant} size="sm" />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={6} className={classes.rightContent}>
            <Grid item>
              <Typography className={classes.valueText} translate="no">
                {transaction.amount}
              </Typography>
            </Grid>
            <Grid item sx={{ width: "40px" }}>
              <TransactionIconsMapping
                type={transaction.type}
                quote={quote.base}
                base={base.base}
              />
            </Grid>
          </Grid>
          {isTablet && (
            <Collapse in={collaspe}>
              <InnerTable
                transactionID={transaction.id}
                note={transaction.note}
                lines={transaction.lines}
                total={transaction.amount}
              />
            </Collapse>
          )}
        </Grid>
      </div>
    );
  }, [collaspe, isTablet]);

  return (
    <>
      {listItem}
      {!isTablet && (
        <TransactionDetails
          toggleDetails={TransactionDetailsToggle}
          details={transaction}
          date={date}
          showTransactionDetails={showTransactionDetails}
        />
      )}
    </>
  );
};

export default TransactionItem;
